import script from "./RecTable.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./RecTable.vue?vue&type=script&setup=true&lang=ts&generic=T"

import "./RecTable.vue?vue&type=style&index=0&id=3bcbc16f&lang=scss"
import "./RecTable.vue?vue&type=style&index=1&id=3bcbc16f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bcbc16f"]])

export default __exports__